import date from './date'

const logout =
{
    ...date,
    label : 'Déconnection : {0}'
};

export default logout ;
